import React from 'react';

const ViewCourseRoyaltyReport = (props) => {
    return (
        <div>
            ViewCourseRoyaltyReport
        </div>
    );
};

export default ViewCourseRoyaltyReport;
